// extracted by mini-css-extract-plugin
export default {"slide":"Slide_slide__h-IXM","title":"Slide_title__mttCX","image":"Slide_image__dB7fL"};